import { useCallback, useMemo, useState } from "react";
import { EditQuizButtonState } from "../editQuiz";

type ModalWrapperButtonType = "back" | "next" | "close" | "save" | "saveProfile";

const INITIAL_BUTTON_STATES: Record<ModalWrapperButtonType, EditQuizButtonState> = {
	back: { enabled: true },
	next: { enabled: true },
	save: { enabled: false },
	close: { enabled: true },
	saveProfile: { enabled: true },
};

export default function useEditQuizButton() {
	const [buttonStates, setButtonStates] = useState(INITIAL_BUTTON_STATES);

	const handleButtonChanges = useCallback((key: ModalWrapperButtonType, changes: Partial<EditQuizButtonState>) => {
		setButtonStates((prev) => ({
			...prev,
			[key]: { ...prev[key], ...changes },
		}));
	}, []);

	const buttonHandlers = useMemo(
		() => ({
			onBackEnabledChange: (changes: Partial<EditQuizButtonState>) => handleButtonChanges("back", changes),
			onNextEnabledChange: (changes: Partial<EditQuizButtonState>) => handleButtonChanges("next", changes),
			onSaveEnabledChange: (changes: Partial<EditQuizButtonState>) => handleButtonChanges("save", changes),
			onSaveProfileChange: (changes: Partial<EditQuizButtonState>) => handleButtonChanges("saveProfile", changes),
		}),
		[handleButtonChanges],
	);

	return {
		handleButtonChanges,
		buttonHandlers,
		backButton: buttonStates.back,
		nextButton: buttonStates.next,
		closeButton: buttonStates.close,
		saveButton: buttonStates.save,
		saveProfileButton: buttonStates.saveProfile,
	};
}
